import { getMultivariateFeatureFlag } from '@atlassian/jira-feature-flagging';

export const COHORT = 'cohort';
export const NOT_ENROLLED = 'not-enrolled';
export const CONTROL = 'control';
export const EXPERIMENT = 'experiment';
export const VARIATION = 'variation';
export const VAR1 = 'variation-1';
export const VAR2 = 'variation-2';
export const VAR3 = 'variation-3';
export const VAR4 = 'variation-4';

const DEFAULT_VALID_EXPERIMENT_GROUPS = [
	NOT_ENROLLED,
	CONTROL,
	EXPERIMENT,
	VARIATION,
	VAR1,
	VAR2,
	VAR3,
	VAR4,
];

// Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	experimentFeatureFlag: string,
	validExperimentGroups: string[] = DEFAULT_VALID_EXPERIMENT_GROUPS,
	// eslint-disable-next-line jira/ff/static-feature-flags
): string => getMultivariateFeatureFlag(experimentFeatureFlag, NOT_ENROLLED, validExperimentGroups);
